import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import "../../Cyclone/DisturbanceTrack/DisturbanceTrack.css";
import DPambulance from "../DP_ambulance/DPambulance";
import AddrecordHospital from "../DP_Health/AddrecordHospital";
import AddBlackspotdata from "../DP_Blackspot/AddBlackspotdata";
import Adddeathdata from "../DP_DeathData/Adddeathdata";
import Reportaccident from "../Reportaccident/Reportaccident";
import Reportroad from "../Reportroad/Reportroad";

const TABS = [
  { id: "roadaccident", label: "Report Road Accident" },
  { id: "roadcondition", label: "Report Road Condition" },
  { id: "ambulance", label: "Ambulance" },
  { id: "hospital", label: "Hospital" },
  { id: "blackspot", label: "Black Spot" },
];

const DataPanelForms = () => {
  const [searchParams] = useSearchParams();
  const initialTab = TABS.some((tab) => tab.id === searchParams.get("tab"))
    ? searchParams.get("tab")
    : "roadaccident";
  const [activeSection, setActiveSection] = useState(initialTab);

  return (
    <div style={{ marginBottom: "1rem" }}>
      <div className="section-buttons-container" style={{ border: "0px" }}>
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`section-button ${activeSection === tab.id ? "active" : ""}`}
            onClick={() => setActiveSection(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="section-content-container">
        <div className={`section-container ${activeSection === "ambulance" ? "active-section" : "hidden-section"}`}>
          <DPambulance />
        </div>
        <div className={`section-container ${activeSection === "hospital" ? "active-section" : "hidden-section"}`}>
          <AddrecordHospital />
        </div>
        <div className={`section-container ${activeSection === "blackspot" ? "active-section" : "hidden-section"}`}>
          <AddBlackspotdata />
        </div>
        <div className={`section-container ${activeSection === "deathdata" ? "active-section" : "hidden-section"}`}>
          <Adddeathdata />
        </div>
        <div className={`section-container ${activeSection === "roadaccident" ? "active-section" : "hidden-section"}`}>
          <Reportaccident />
        </div>
        <div className={`section-container ${activeSection === "roadcondition" ? "active-section" : "hidden-section"}`}>
          <Reportroad />
        </div>
      </div>
    </div>
  );
};

export default DataPanelForms;
